import { createApp } from 'vue';
import i18n from '@/i18n';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { getAppFromSpaWrapper, getEnvVar } from '@/utils/env';
import authFactory from '@/config/authFactory';
import sentryConfig from '@/config/sentryConfig';
import PrimeVue from 'primevue/config';
import DialogService from 'primevue/dialogservice';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmationService from 'primevue/confirmationservice';
import DynamicDialog from 'primevue/dynamicdialog';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import { addSpaStaticsToHead } from './utils/spa-statics';
import '@/assets/scss/themes/acv-default/gqt-theme.scss';

addSpaStaticsToHead();

const SPA_URL = getEnvVar('VITE_CDN_BASE_URL');

// dataLayer initialization in case we are not in CMS environment
window.dataLayer = window.dataLayer ?? [];

const auth = authFactory().getInstance();

const app = createApp(App);

sentryConfig().initialize(app);

app.use(i18n);
app.use(createPinia());
app.use(router);
app.use(auth);
app.use(PrimeVue, { theme: 'none' });
app.use(ToastService);
app.use(DialogService);
app.use(ConfirmationService);
app.component('Toast', Toast);
app.component('DynamicDialog', DynamicDialog);
app.component('ConfirmDialog', ConfirmDialog);
app.directive('tooltip', Tooltip);
app.mount(getAppFromSpaWrapper() ?? '#app');

let linkElem = document.createElement('link');
linkElem.setAttribute('rel', 'canonical');
linkElem.setAttribute('href', 'https://www.hostedpci.com/iframe-demo-interactive/');
document.head.append(linkElem);

linkElem = document.createElement('link');
linkElem.setAttribute('rel', 'alternate');
linkElem.setAttribute('type', 'application/json+oembed');
linkElem.setAttribute('href', 'https://www.hostedpci.com/wp-json/oembed/1.0/embed?url=https%3A%2F%2Fwww.hostedpci.com%2Fiframe-demo-interactive%2F');
document.head.append(linkElem);

linkElem = document.createElement('link');
linkElem.setAttribute('rel', 'alternate');
linkElem.setAttribute('type', 'text/xml+oembed');
linkElem.setAttribute('href', 'https://www.hostedpci.com/wp-json/oembed/1.0/embed?url=https%3A%2F%2Fwww.hostedpci.com%2Fiframe-demo-interactive%2F&amp;format=xml');
document.head.append(linkElem);

const loadScript = (scriptUrl: string, async = true, type = 'text/javascript') => {
  return new Promise((resolve, reject) => {
    try {
      const scriptEle = document.createElement('script');
      scriptEle.type = type;
      scriptEle.async = async;
      scriptEle.src = scriptUrl;
      scriptEle.defer = async;

      scriptEle.addEventListener('load', () => {
        resolve({ status: true });
      });

      document.body.appendChild(scriptEle);
    } catch (error) {
      reject(error as Error);
    }
  });
};

// Scripts are launched here instead of having them in index.html due to
// the endpoint https://{env}-gqt-spa.vacv-nonprod.click/ otherwise they are missing...
loadScript('https://ccframe.hostedpci.com/WBSStatic/site60/proxy/js/jquery-3.4.1.min.js')
  .then(() => {
    Promise.all([
      loadScript('https://cdnjs.cloudflare.com/ajax/libs/jquery-cookie/1.4.1/jquery.cookie.min.js'),
      loadScript('https://ccframe.hostedpci.com/WBSStatic/site60/proxy/js/jquery.ba-postmessage.2.0.0.min.js'),
      loadScript('https://ccframe.hostedpci.com/WBSStatic/site60/proxy/js/hpci-cciframe-1.0.js'),
      loadScript(`${SPA_URL}/assets/js/pay.js`)
    ]).then((data) => {
      // eslint-disable-next-line no-undef
      jQuery.noConflict();
      // eslint-disable-next-line no-console
      console.info('(%d) Scripts loaded successfully', data?.length);
    });
  })
  .catch((err) => {
    // eslint-disable-next-line no-console
    console.error(err);
  });
